import React from 'react';



const About = () =>{
    return <h1>About Section</h1>
};

export default About;
